// extracted by mini-css-extract-plugin
export var accordion = "_d5-0";
export var chevron = "_d5-3";
export var closed = "_d5-2";
export var content = "_d5-4";
export var open = "_d5-1";
export var rotate = "_d5-5";